module.exports = __webpack_public_path__ + "static/media/alerta-documentacion-auto-rojo.86154767.svg";